import { render, staticRenderFns } from "./number-grow-warp.vue?vue&type=template&id=2c753726&"
import script from "./number-grow-warp.vue?vue&type=script&lang=js&"
export * from "./number-grow-warp.vue?vue&type=script&lang=js&"
import style0 from "./number-grow-warp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports